export default class Nav {
  constructor() {
    const hamburgerMenu = document.querySelectorAll('.hamburger-menu'),
    fixedTop = document.querySelector('.fixed-top'),
    dropdowns = document.querySelectorAll('.dropdown-toggle'),
    closeButtons = document.querySelectorAll('.btn-close');
    
    if (fixedTop) {
      this.scrollNav();
    }
    if (hamburgerMenu.length) {
      this.hamburgerMenu = hamburgerMenu;
      this.initSideNavState();
    }
    if (dropdowns.length) {
      this.dropdowns = dropdowns;
      this.hideDropdownOnClick();
    }
    if (closeButtons.length) {
      this.closeButtons = closeButtons;
      this.initCloseButtons();
    }
  }
  
  // Function to initialize the active state of the navigation
  initNavActiveState() {
    if (location.pathname != '/') {
      $('.main-nav li a[href^="/' + location.pathname.split("/")[1] + '"]').addClass('active');
    }
  }
  
  // Function to add the class is-scrolling to the fixed-top element
  scrollNav() {
    const fixedTop = document.querySelector('.fixed-top'),
    hNavbar = document.querySelector('.h-navbar');
    
    let previousScroll = 0;
    let desktopScrollHandler = null;
    let mobileScrollHandler = null;
    
    // Function to set up desktop scroll behavior
    const setupDesktopScroll = () => {
      if (desktopScrollHandler) {
        window.removeEventListener('scroll', desktopScrollHandler);
      }
      
      desktopScrollHandler = function () {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll < 100) {
          // At the top of the page
          fixedTop.classList.remove('is-scrolling');
        } else {
          fixedTop.classList.add('is-scrolling');
        }
        
        previousScroll = currentScroll;
      };
      
      window.addEventListener('scroll', desktopScrollHandler);
    };
    
    // Function to set up mobile scroll behavior
    const setupMobileScroll = () => {
      if (mobileScrollHandler) {
        window.removeEventListener('scroll', mobileScrollHandler);
      }
      
      mobileScrollHandler = function () {
        const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScroll < 100) {
          // At the top of the page - always show
          hNavbar.classList.remove('is-scrolling');
          hNavbar.classList.remove('navbar-hidden');
          fixedTop.classList.remove('is-hidden');
        } else if (currentScroll < previousScroll) {
          // Scrolling up - show navbar
          hNavbar.classList.add('is-scrolling');
          hNavbar.classList.remove('navbar-hidden');
          fixedTop.classList.remove('is-hidden');
        } else if (currentScroll > previousScroll) {
          // Scrolling down - hide navbar
          hNavbar.classList.add('is-scrolling');
          hNavbar.classList.add('navbar-hidden');
          fixedTop.classList.add('is-hidden');
        }
        
        previousScroll = currentScroll;
      };
      
      window.addEventListener('scroll', mobileScrollHandler);
    };
    
    // Function to clean up all scroll listeners
    const cleanupScrollListeners = () => {
      if (desktopScrollHandler) {
        window.removeEventListener('scroll', desktopScrollHandler);
        desktopScrollHandler = null;
      }
      if (mobileScrollHandler) {
        window.removeEventListener('scroll', mobileScrollHandler);
        mobileScrollHandler = null;
      }
    };
    
    // Function to reset navbar classes
    const resetNavbarClasses = () => {
      if (hNavbar) {
        hNavbar.classList.remove('is-scrolling', 'navbar-hidden');
      }
      if (fixedTop) {
        fixedTop.classList.remove('is-scrolling', 'is-hidden');
      }
    };
    
    // Function to initialize scroll behavior based on screen size
    const initScrollBehavior = () => {
      cleanupScrollListeners();
      resetNavbarClasses();
      
      if (fixedTop && window.innerWidth >= 992) {
        setupDesktopScroll();
      } else if (hNavbar && window.innerWidth <= 991) {
        setupMobileScroll();
      }
    };
    
    // Initialize on load
    initScrollBehavior();
    
    // Add resize listener
    window.addEventListener('resize', function() {
      // Debounce resize events
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => {
        initScrollBehavior();
      }, 250);
    });
  }
  
  // Function to initialize the mobile navigation state
  initSideNavState() {
    const mobileOverlay = document.querySelector('.mobile-overlay'),
    body = document.querySelector('body'),
    mobileNav = document.querySelector('.mobile-nav'),
    mobileCloseNav = document.querySelector('.close-mobile-nav');
    
    if (this.hamburgerMenu) {
      this.hamburgerMenu.forEach (burger => {
        burger.addEventListener('click', function() {
          mobileNav.classList.add('active');
          mobileCloseNav.classList.add('open');
          mobileOverlay.classList.add('open');
          
          if (mobileOverlay.classList.contains('open')) {
            body.classList.add('overflow-hidden');
          }
        });
      });
    }
    
    if (mobileCloseNav) {
      mobileCloseNav.addEventListener('click', function() {
        mobileNav.classList.remove('active');
        mobileCloseNav.classList.remove('open');
        mobileOverlay.classList.remove('open');
        body.classList.remove('overflow-hidden');
      });
    }
  }
  
  // Function to hide main menu dropdown when clicking them
  // and to redirect to the href of the platform dropdown
  hideDropdownOnClick() {
    this.dropdowns.forEach(dropdown => {
      dropdown.addEventListener('click', function () {
        const dropdownMenu = dropdown.nextElementSibling;
        if (dropdownMenu && window.innerWidth >= '768') {
          dropdownMenu.classList.add('d-none');
        }
      });
    });
    
    const platform = document.getElementById('platform-dropdown');
    
    if (platform && window.innerWidth >= '768') {
      platform.addEventListener('click', function (e) {
        e.preventDefault();
        
        const url = platform.getAttribute('href');
        if (url) {
          window.location = url;
        }
      });
    }
    if (platform && window.innerWidth < '767') {
      platform.removeAttribute('href');
      platform.removeAttribute('data-url');
    }
  }
  
  initCloseButtons() {
    this.closeButtons.forEach(closeBtn => {
      closeBtn.addEventListener('click', function() {
        const dropdownMenu = document.querySelector('.dropdown-menu');
        
        if (dropdownMenu) {
          dropdownMenu.classList.remove('show');
          dropdownMenu.style.display = '';
          console.log({dropdownMenu});
        }
      });
    });
  }
}